
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
   loginInfo:{},
   getEmailAndOTP:{
    emailId:""
   },
   menuList:[]
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginDetail: (state,actions) => {
      state.loginInfo = actions.payload.loginInfo
      state.menuList = actions.payload.menuList
    },
    updateAccessToken: (state, actions) => {
      state.loginInfo.jwtToken = actions.payload.jwtToken;
      state.loginInfo.refreshToken = actions.payload.refreshToken; 
    },
    logout: (state) => {
      state.loginInfo = {}; 
      state.getEmailAndOTP={emailId:""}
    },
    getOTPAndEmail:(state,actions)=>{
      state.getEmailAndOTP=actions.payload
    },
    menuList: (state, actions) => {
      state.menuList = actions.payload;
    },


   
  },
})


 export const { logout , getOTPAndEmail,menuList,updateAccessToken,loginDetail } = authSlice.actions

export const authReducers= authSlice.reducer




